export function getSystemObjectColorClass<T extends { Id: number; IsSystemObject?: boolean }>(
    items: T[],
): (itemId: number) => string {
    return (itemId: number): string => {
        const currentItem = items?.find((item) => item.Id === itemId);
        return currentItem?.IsSystemObject ? 'color-red' : '';
    };
}
